function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgModalIcon4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 8847"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45576",
    d: "M-1197.012-344.931q0 15.708.012 31.417c0 .425-.081.512-.51.512q-31.482-.021-62.963 0c-.491 0-.524-.151-.524-.56q.014-31.448 0-62.9c0-.447.089-.543.541-.543q31.45.021 62.9 0c.5 0 .557.149.557.59q-.022 15.744-.013 31.484z",
    style: {
      fill: "#fefefe"
    },
    transform: "translate(1261 377)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45577",
    d: "M-1248.195-340.5v-28.368a2.017 2.017 0 0 1 2.151-2.066h55.494a2.039 2.039 0 0 1 2.214 2.192v28.243a1.971 1.971 0 0 1-2.059 1.664c-1.092.025-2.184.009-3.276 0a1.1 1.1 0 0 1-.655-.135 7.333 7.333 0 0 1-.269-2.044c.262-.233.587-.159.891-.172.269-.011.539 0 .809 0 1.214-.007 1.475-.295 1.353-1.491.063-1.017.042-2.036.028-3.054-.011-.778-.289-1.054-1.059-1.073q-1.246-.03-2.494 0c-.767.02-1.042.3-1.053 1.078-.015 1-.029 1.995.024 2.991a2.064 2.064 0 0 1-.144.7c-.309.3-.782.236-1.1.508a2.971 2.971 0 0 0-.649.7c-.084.12-.168.309-.37.133a1.831 1.831 0 0 1-.132-.969c-.012-.97.023-1.94-.052-2.909a4.511 4.511 0 0 0 .048-1.236c-.027-.7-.293-.967-1-1-.662-.03-1.325 0-1.987-.011a1.611 1.611 0 0 1-.79-.113 1.134 1.134 0 0 1-.256-1.11 2.626 2.626 0 0 1 1.275-.132c.474-.018.95 0 1.425 0 1.147-.008 1.418-.316 1.3-1.473.064-1.016.043-2.032.029-3.048-.01-.811-.285-1.077-1.1-1.094s-1.618-.018-2.427 0-1.071.293-1.082 1.112c-.012 1-.029 1.991.027 2.986-.069.307.009.642-.169.929-.695 0-1.39-.025-2.086.012-.189-.286-.105-.622-.176-.93.06-1 .038-1.992.028-2.987-.008-.843-.281-1.106-1.135-1.122q-1.182-.022-2.366 0c-.814.016-1.093.282-1.106 1.088-.016 1.016-.032 2.033.029 3.049-.125 1.154.151 1.47 1.3 1.478h2.048a1.072 1.072 0 0 1 .657.138 1.085 1.085 0 0 1-.322 1.142 2.372 2.372 0 0 1-.922.1h-21.908a2.612 2.612 0 0 1-.924-.087 1.016 1.016 0 0 1-.372-1.135 1.375 1.375 0 0 1 .891-.156c.617-.009 1.234 0 1.851 0 1.14-.008 1.414-.319 1.3-1.468.064-1.016.043-2.034.029-3.051-.01-.812-.285-1.077-1.1-1.1a62.981 62.981 0 0 0-2.3 0c-.933.011-1.2.264-1.2 1.182-.008.976-.028 1.952.03 2.927-.071.308.01.645-.169.934-.032.026-.072.07-.1.062a9.767 9.767 0 0 0-1.988-.069c-.187-.294-.105-.637-.175-.952.052-.973.034-1.948.024-2.921-.009-.853-.277-1.145-1.109-1.15q-4.694-.028-9.389 0c-.8 0-1.071.3-1.081 1.111-.013 1.015-.025 2.031.028 3.046-.112 1.093.183 1.431 1.3 1.434 2.88.008 5.76 0 8.641 0a2.367 2.367 0 0 1 .982.1c.291.428.01.773-.164 1.135a5.333 5.333 0 0 1-2.03.129c-1.695.024-1.854.174-1.791 1.859 0 .125.04.246.045.37-.062.852-.017 1.707-.043 2.559a5.518 5.518 0 0 1-.07 1.4c-.087.176-.246.2-.322.042a3.2 3.2 0 0 0-1.84-1.421 1.872 1.872 0 0 1-.158-.706c.057-.992.036-1.986.026-2.978-.008-.814-.279-1.088-1.08-1.107s-1.614-.017-2.421 0c-.833.016-1.1.285-1.109 1.143-.01.993-.031 1.986.03 2.978-.13 1.2.133 1.474 1.335 1.506a3.491 3.491 0 0 1 1.7.152 7.28 7.28 0 0 1-.24 2.046 1.024 1.024 0 0 1-.653.148c-1.1.006-2.193.021-3.29 0a1.937 1.937 0 0 1-2.08-1.668z",
    transform: "translate(1250.332 371.944)",
    style: {
      fill: "#e5e8ec"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45578",
    d: "M-1037.767-231.9a1.725 1.725 0 0 1 1.123-.373 1.406 1.406 0 0 1 1.753 1 4.244 4.244 0 0 1 .25 1.989 2.433 2.433 0 0 1 0 2.005q0 5.888-.006 11.775a7.871 7.871 0 0 1-3.592 6.851.776.776 0 0 0-.407.758c.032.517.007 1.038.006 1.557a1.05 1.05 0 0 1-.82.2q-3.168.01-6.336 0a1.048 1.048 0 0 1-.82-.2 3.134 3.134 0 0 0-1.35-3.323 13.548 13.548 0 0 1-2.943-3.742q-2.529-3.728-5.063-7.453a3.681 3.681 0 0 1-.5-.992 1.869 1.869 0 0 1 .743-2.237 1.991 1.991 0 0 1 2.265.107 25.641 25.641 0 0 1 2.212 2.094 5.041 5.041 0 0 1 .456.579l.182-.106v-5.871a4.348 4.348 0 0 1-.177-1.98c-.014-.655-.02-1.31 0-1.964 0-.334-.014-.668 0-1q-.005-.872 0-1.743a2.281 2.281 0 0 1 1.792-2.428 2.287 2.287 0 0 1 2.507 1.591 4.294 4.294 0 0 1 .059.993c0 3.115 0 6.23.01 9.345 0 .257-.162.714.208.728.335.013.379-.441.383-.753.025-2.284.007-4.569.011-6.853 0-1.08-.031-2.161.011-3.239a1.541 1.541 0 0 0-.848-1.642.9.9 0 0 1 .024-1.03 2.381 2.381 0 0 1 .257-1 .828.828 0 0 1 .748-.749 2.127 2.127 0 0 1 2 0c.414.088.719.283.752.752a2.435 2.435 0 0 1 .258 1c.243.3.16.66.18 1a7.638 7.638 0 0 0 .051 1.4c-.1 3.528-.02 7.058-.045 10.587a1.821 1.821 0 0 0 .016.311c.017.1.026.222.148.246s.192-.062.251-.148a1.6 1.6 0 0 0 .189-.962v-6.229c0-1.578-.007-3.156 0-4.733a.32.32 0 0 1 .094-.283 1.765 1.765 0 0 1 1.868-.207c.593.247 1.156.576 1.11 1.368a21.012 21.012 0 0 1 .117 3.287c.013.238-.1.5.116.71.152.182.09.395.086.6-.033 2.015-.006 4.031-.014 6.046a1.774 1.774 0 0 0 .016.311c.017.1.019.222.144.246.146.028.223-.087.289-.192a1.612 1.612 0 0 0 .163-.907q.006-3.117 0-6.233a3.753 3.753 0 0 1 .073-.864z",
    transform: "translate(1090.654 262.214)",
    style: {
      fill: "#e9c5ba"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45579",
    d: "M-1213.411-229.272a4.241 4.241 0 0 1 .252-1.989 1.405 1.405 0 0 1 1.752-1 2.287 2.287 0 0 1 1.989 1.493c.251.254.189.58.191.883.008 1.783 0 3.567 0 5.35a5.028 5.028 0 0 0 .012.559c.014.12.014.275.167.3.134.018.218-.1.285-.205a1.213 1.213 0 0 0 .15-.659c.008-2.136-.011-4.272.012-6.407a1.569 1.569 0 0 0-.808-1.3 12.029 12.029 0 0 1 .1-2.635 1.862 1.862 0 0 1 2.512-1.408 2.383 2.383 0 0 1 1.509 1.683 18.964 18.964 0 0 1 .048 2.366c.008 2.618 0 5.236.01 7.854 0 .24-.139.656.2.672.322.015.371-.4.385-.686.039-.81.015-1.62.016-2.43 0-2.577-.018-5.153.013-7.729a1.568 1.568 0 0 0-.848-1.643.909.909 0 0 1 .017-1.029 2.458 2.458 0 0 1 .26-1 .766.766 0 0 1 .752-.752 2.14 2.14 0 0 1 2 0 .822.822 0 0 1 .747.748l.256 1c.246.3.167.659.185 1a7.6 7.6 0 0 0 .051 1.4c-.1 3.524-.022 7.05-.038 10.575 0 .195-.12.538.205.548.248.007.293-.312.343-.532a4.194 4.194 0 0 0 .05-.93v-10.639c.066-.383.387-.457.682-.535a2.2 2.2 0 0 1 2.671 2.128c.045.66.017 1.322.012 1.984.017.338.009.676 0 1.014.021.658.018 1.315 0 1.972-.044.664.175 1.352-.178 1.988 0 1.764-.008 3.527 0 5.291 0 .17-.11.426.111.5.189.06.3-.178.432-.3.654-.637 1.283-1.3 1.955-1.918a1.987 1.987 0 0 1 3.438.833 2.379 2.379 0 0 1-.518 1.926c-2.3 3.4-4.6 6.787-6.945 10.149a7.675 7.675 0 0 1-2.047 1.98.821.821 0 0 0-.429.81c.028.559.005 1.12 0 1.68a1.047 1.047 0 0 1-.819.2q-3.168.01-6.336 0a1.052 1.052 0 0 1-.82-.2 2.934 2.934 0 0 0-1.213-2.992 7.374 7.374 0 0 1-2.788-6.3c.03-3.883 0-7.767 0-11.651a2.461 2.461 0 0 1 .017-2.017z",
    transform: "translate(1221.522 262.203)",
    style: {
      fill: "#e9c5ba"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45580",
    d: "M-997.788-24.806c.791.206.993.455 1 1.252s-.009 1.576.006 2.364c.005.287-.073.4-.381.4q-5.6-.013-11.2 0c-.353 0-.406-.146-.4-.444.015-.767 0-1.535.006-2.3.005-.8.209-1.053.988-1.27a1.227 1.227 0 0 1 .831-.182q4.161-.006 8.322 0a1.227 1.227 0 0 1 .828.18z",
    transform: "translate(1050.805 83.658)",
    style: {
      fill: "#656d78"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45581",
    d: "M-1189.4-24.805c.775.218.982.479.988 1.272.005.747-.014 1.494.008 2.24.01.354-.053.51-.466.508q-5.538-.025-11.075 0c-.367 0-.453-.124-.444-.464.022-.767 0-1.535.008-2.3 0-.8.206-1.046 1-1.252a1.227 1.227 0 0 1 .831-.181q4.161-.006 8.322 0a1.226 1.226 0 0 1 .828.177z",
    transform: "translate(1210.495 83.658)",
    style: {
      fill: "#656d78"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45582",
    d: "M-1116.493-178.414v-2a1.128 1.128 0 0 1 .825-.2q7.152-.007 14.3 0a1.127 1.127 0 0 1 .825.2v2z",
    transform: "translate(1140.578 213.348)",
    style: {
      fill: "#cbd0d8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45583",
    d: "M-992.818-38.756h-9.984c0-.614 0-1.228.005-1.842.008-.726.258-1 1-1.133h7.976c.741.13.99.408 1 1.134.005.614.002 1.227.003 1.841z",
    transform: "translate(1045.835 97.609)",
    style: {
      fill: "#e5e8ec"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45584",
    d: "M-1184.373-38.758h-9.984c0-.613 0-1.226.005-1.839.008-.726.255-1 1-1.135h7.976c.744.128.995.406 1 1.132.005.614.002 1.228.003 1.842z",
    transform: "translate(1205.464 97.611)",
    style: {
      fill: "#e5e8ec"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45585",
    d: "M-924.925-184.831v-2.005c1.138 0 2.28-.053 3.413.018a2.381 2.381 0 0 0 2.562-1.5c0 .5.012.991 0 1.487a1.99 1.99 0 0 1-2.011 1.994c-1.321.009-2.639.004-3.964.006z",
    transform: "translate(980.939 219.768)",
    style: {
      fill: "#cbd0d8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45586",
    d: "M-1242.229-186.838v2.008c-1.3 0-2.6 0-3.9-.01a1.987 1.987 0 0 1-2.073-2.058v-1.424a2.347 2.347 0 0 0 2.558 1.5c1.134-.07 2.276-.015 3.415-.016z",
    transform: "translate(1250.34 219.769)",
    style: {
      fill: "#cbd0d8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45587",
    d: "M-1136.562-222.278c0-.661.017-1.323-.012-1.983a1.984 1.984 0 0 0-3.115-1.635 3.829 3.829 0 0 1-.751.992 8.973 8.973 0 0 1-.111-2.355h23.93l.024 1a1.237 1.237 0 0 1-.025 1.353 4.09 4.09 0 0 0-.89-1.013 1.847 1.847 0 0 0-1.945-.143 1.929 1.929 0 0 0-1.141 1.726c-.021.685-.009 1.371-.011 2.056a1.1 1.1 0 0 1-.822.207q-7.154.007-14.308 0a1.11 1.11 0 0 1-.823-.205z",
    transform: "translate(1160.647 252.216)",
    style: {
      fill: "#fefefe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45588",
    d: "M-1230.287-264.8a14.869 14.869 0 0 1-.064-3.652c.026-.471.453-.725.951-.725h9.967c.5 0 .926.253.952.723a14.626 14.626 0 0 1-.065 3.651c.087.428-.2.589-.522.716a2.128 2.128 0 0 1-.8.092h-9.091a2.132 2.132 0 0 1-.8-.091c-.316-.125-.613-.282-.528-.714z",
    transform: "translate(1235.527 287.148)",
    style: {
      fill: "#fefefe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45589",
    d: "M-936.824-299.725a1.691 1.691 0 0 1-.116-.792v-9.283c0-.983.31-1.286 1.309-1.287.852 0 1.7-.006 2.555 0 .755.007 1.121.356 1.122 1.1.006 3.219 0 6.438.005 9.657a1.449 1.449 0 0 1-.119.6c.084.545-.314.712-.7.747a18.769 18.769 0 0 1-3.35 0c-.382-.031-.782-.2-.706-.742z",
    transform: "translate(990.95 322.075)",
    style: {
      fill: "#fefefe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45590",
    d: "M-1104.58-264.806a14.889 14.889 0 0 1-.065-3.65c.025-.471.451-.725.948-.727q1.494-.007 2.988 0c.5 0 .924.254.95.725a14.646 14.646 0 0 1-.065 3.65c.084.545-.315.712-.7.747a18.776 18.776 0 0 1-3.35 0c-.386-.034-.782-.202-.706-.745z",
    transform: "translate(1130.771 287.156)",
    style: {
      fill: "#fefefe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45591",
    d: "M-936.97-222.907a14.891 14.891 0 0 1-.064-3.65c.025-.47.451-.724.948-.727q1.494-.007 2.988 0c.5 0 .924.255.95.725a14.651 14.651 0 0 1-.065 3.65c.085.5-.267.7-.632.731a11.438 11.438 0 0 1-3.5-.073c-.302-.069-.722-.149-.625-.656z",
    transform: "translate(991.095 252.239)",
    style: {
      fill: "#fefefe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45592",
    d: "M-1230.288-222.907a14.882 14.882 0 0 1-.064-3.65c.025-.47.451-.725.948-.727q1.494-.007 2.988 0c.5 0 .924.255.95.725a14.651 14.651 0 0 1-.065 3.649c.1.279-.064.417-.279.53a2.221 2.221 0 0 1-.946.253 24.215 24.215 0 0 1-2.651-.009c-.449-.032-.925-.13-.881-.771z",
    transform: "translate(1235.527 252.239)",
    style: {
      fill: "#fefefe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45593",
    d: "M-978.872-264.806a14.89 14.89 0 0 1-.064-3.651c.025-.47.451-.724.948-.727q1.494-.007 2.988 0c.5 0 .924.254.95.725a14.651 14.651 0 0 1-.065 3.649c.084.545-.315.712-.7.747a18.774 18.774 0 0 1-3.35 0c-.388-.032-.784-.2-.707-.743z",
    transform: "translate(1026.014 287.156)",
    style: {
      fill: "#fefefe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45594",
    d: "M-1230.288-306.705a14.884 14.884 0 0 1-.064-3.651c.025-.47.451-.724.948-.727q1.494-.007 2.988 0c.5 0 .924.254.95.725a14.652 14.652 0 0 1-.065 3.65c.084.545-.314.712-.7.747a18.789 18.789 0 0 1-3.35 0c-.388-.033-.784-.201-.707-.744z",
    transform: "translate(1235.527 322.072)",
    style: {
      fill: "#fefefe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45595",
    d: "M-1188.385-306.705a14.878 14.878 0 0 1-.065-3.651c.025-.47.451-.724.948-.727q1.494-.007 2.988 0c.5 0 .924.254.95.725a14.641 14.641 0 0 1-.066 3.65c.084.545-.314.712-.7.747a18.789 18.789 0 0 1-3.35 0c-.386-.033-.782-.201-.705-.744z",
    transform: "translate(1200.609 322.072)",
    style: {
      fill: "#fefefe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45596",
    d: "M-1146.482-306.705a14.89 14.89 0 0 1-.064-3.651c.025-.47.451-.724.948-.727q1.494-.007 2.988 0c.5 0 .924.254.95.725a14.652 14.652 0 0 1-.065 3.65c.084.545-.314.712-.7.747a18.789 18.789 0 0 1-3.35 0c-.388-.033-.784-.201-.707-.744z",
    transform: "translate(1165.69 322.072)",
    style: {
      fill: "#fefefe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45597",
    d: "M-1104.58-306.705a14.89 14.89 0 0 1-.065-3.651c.025-.47.451-.724.948-.727q1.494-.007 2.988 0c.5 0 .924.254.95.725a14.646 14.646 0 0 1-.065 3.65c.084.545-.315.712-.7.747a18.79 18.79 0 0 1-3.35 0c-.386-.033-.782-.201-.706-.744z",
    transform: "translate(1130.771 322.072)",
    style: {
      fill: "#fefefe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45598",
    d: "M-1062.677-306.705a14.884 14.884 0 0 1-.064-3.651c.025-.47.451-.724.948-.727q1.494-.007 2.988 0c.5 0 .924.254.95.725a14.647 14.647 0 0 1-.066 3.65c.084.545-.314.712-.7.747a18.789 18.789 0 0 1-3.35 0c-.387-.033-.783-.201-.706-.744z",
    transform: "translate(1095.852 322.072)",
    style: {
      fill: "#fefefe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45599",
    d: "M-1020.774-306.705a14.893 14.893 0 0 1-.065-3.651c.025-.47.451-.724.948-.727q1.494-.007 2.988 0c.5 0 .924.254.95.725a14.644 14.644 0 0 1-.066 3.65c.084.545-.314.712-.7.747a18.775 18.775 0 0 1-3.35 0c-.386-.033-.782-.201-.705-.744z",
    transform: "translate(1060.933 322.072)",
    style: {
      fill: "#fefefe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45600",
    d: "M-978.872-306.705a14.881 14.881 0 0 1-.065-3.651c.025-.47.451-.724.948-.727q1.494-.007 2.988 0c.5 0 .924.254.95.725a14.652 14.652 0 0 1-.066 3.65c.084.545-.314.712-.7.747a18.774 18.774 0 0 1-3.35 0c-.386-.033-.782-.201-.705-.744z",
    transform: "translate(1026.014 322.072)",
    style: {
      fill: "#fefefe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45601",
    d: "M-1020.774-264.806a14.892 14.892 0 0 1-.065-3.65c.025-.471.451-.725.948-.727q1.494-.007 2.988 0c.5 0 .924.254.95.725a14.652 14.652 0 0 1-.065 3.65c.084.545-.315.712-.7.747a18.775 18.775 0 0 1-3.35 0c-.387-.034-.783-.202-.706-.745z",
    transform: "translate(1060.933 287.156)",
    style: {
      fill: "#fefefe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45602",
    d: "M-1062.677-264.806a14.882 14.882 0 0 1-.064-3.65c.025-.471.451-.725.948-.727q1.494-.007 2.988 0c.5 0 .924.254.95.725a14.652 14.652 0 0 1-.066 3.65c.084.545-.314.712-.7.747a18.774 18.774 0 0 1-3.35 0c-.387-.034-.783-.202-.706-.745z",
    transform: "translate(1095.852 287.156)",
    style: {
      fill: "#fefefe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45603",
    d: "M-1146.482-264.806a14.89 14.89 0 0 1-.064-3.651c.025-.47.451-.724.948-.727q1.494-.007 2.988 0c.5 0 .924.255.95.725a14.645 14.645 0 0 1-.065 3.649c.084.545-.314.712-.7.747a18.774 18.774 0 0 1-3.35 0c-.388-.032-.784-.2-.707-.743z",
    transform: "translate(1165.689 287.156)",
    style: {
      fill: "#fefefe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45604",
    d: "M-936.742-349.8a2.4 2.4 0 0 1 .928-2.775 2.412 2.412 0 0 1 2.981.062A2.423 2.423 0 0 1-932-349.8a2.078 2.078 0 0 1-1.859 1.845 2.636 2.636 0 0 1-2.737-1.155.759.759 0 0 1-.146-.69z",
    transform: "translate(990.876 357.046)",
    style: {
      fill: "#fefefe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45605",
    d: "M-1062.45-349.8a2.4 2.4 0 0 1 .927-2.775 2.412 2.412 0 0 1 2.981.062 2.423 2.423 0 0 1 .835 2.711 2.078 2.078 0 0 1-1.859 1.845 2.636 2.636 0 0 1-2.737-1.155.759.759 0 0 1-.147-.688z",
    transform: "translate(1095.632 357.046)",
    style: {
      fill: "#fefefe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45606",
    d: "M-978.644-349.8a2.4 2.4 0 0 1 .927-2.775 2.413 2.413 0 0 1 2.981.062 2.423 2.423 0 0 1 .835 2.711 2.078 2.078 0 0 1-1.859 1.845 2.636 2.636 0 0 1-2.737-1.155.759.759 0 0 1-.147-.688z",
    transform: "translate(1025.794 357.046)",
    style: {
      fill: "#fefefe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45607",
    d: "M-1020.547-349.8a2.4 2.4 0 0 1 .927-2.775 2.412 2.412 0 0 1 2.981.062 2.424 2.424 0 0 1 .835 2.711 2.078 2.078 0 0 1-1.859 1.845 2.636 2.636 0 0 1-2.737-1.155.759.759 0 0 1-.147-.688z",
    transform: "translate(1060.714 357.046)",
    style: {
      fill: "#fefefe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45608",
    d: "M-1230.06-349.8a2.4 2.4 0 0 1 .927-2.775 2.412 2.412 0 0 1 2.981.062 2.423 2.423 0 0 1 .835 2.711 2.078 2.078 0 0 1-1.859 1.845 2.636 2.636 0 0 1-2.737-1.155.759.759 0 0 1-.147-.688z",
    transform: "translate(1235.308 357.046)",
    style: {
      fill: "#fefefe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45609",
    d: "M-1188.157-349.8a2.4 2.4 0 0 1 .927-2.775 2.413 2.413 0 0 1 2.981.062 2.424 2.424 0 0 1 .834 2.711 2.078 2.078 0 0 1-1.859 1.845 2.636 2.636 0 0 1-2.737-1.155.759.759 0 0 1-.146-.688z",
    transform: "translate(1200.389 357.046)",
    style: {
      fill: "#fefefe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45610",
    d: "M-1104.352-349.8a2.4 2.4 0 0 1 .927-2.775 2.412 2.412 0 0 1 2.981.062 2.423 2.423 0 0 1 .834 2.711 2.078 2.078 0 0 1-1.859 1.845 2.636 2.636 0 0 1-2.737-1.155.76.76 0 0 1-.146-.688z",
    transform: "translate(1130.551 357.046)",
    style: {
      fill: "#fefefe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45611",
    d: "M-1146.255-349.8a2.4 2.4 0 0 1 .928-2.775 2.412 2.412 0 0 1 2.981.062 2.423 2.423 0 0 1 .835 2.711 2.078 2.078 0 0 1-1.859 1.845 2.636 2.636 0 0 1-2.737-1.155.759.759 0 0 1-.148-.688z",
    transform: "translate(1165.47 357.046)",
    style: {
      fill: "#fefefe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45612",
    d: "M-1230.133-242.918a.829.829 0 0 0 .9.605q4.971.008 9.942 0a.823.823 0 0 0 .9-.608c.229.26.068.574.117.859a2.854 2.854 0 0 0-.752.752h-10.021c-1.017-.004-1.417-.603-1.086-1.608z",
    transform: "translate(1235.372 265.268)",
    style: {
      fill: "#cbd0d8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45613",
    d: "M-1188.463-197.325c.727.126.986.4.988 1.1.007 2.264 0 4.527.005 6.791a1.105 1.105 0 0 1-.17.65c-.159.233-.388.447-.661.387-.3-.066-.162-.386-.163-.591-.011-2.284-.01-4.569-.011-6.853z",
    transform: "translate(1200.579 227.271)",
    style: {
      fill: "#d2b0a8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45614",
    d: "M-948.029-195.129c.192.162.124.384.124.583 0 2.282 0 4.564.006 6.845a1.051 1.051 0 0 1-.563 1.083c-.274.135-.438.1-.438-.249 0-2.261 0-4.522.01-6.783a2.221 2.221 0 0 1 .11-.481 1.6 1.6 0 0 1 .751-.998z",
    transform: "translate(1000.916 225.441)",
    style: {
      fill: "#d2b0a8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45615",
    d: "m-1184.545-227.277.025 1a1.41 1.41 0 0 1-.019 1.48c-.318-.415-.483-.934-1.011-1.2a1.938 1.938 0 0 0-2.86 1.078 2.945 2.945 0 0 1-.044-1.692.9.9 0 0 1 .995-.667c.971 0 1.942-.001 2.914.001z",
    transform: "translate(1200.63 252.238)",
    style: {
      fill: "#fefefe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45616",
    d: "M-969.047-224.917a1.944 1.944 0 0 0-3.007-.991 4.239 4.239 0 0 1-.75.995 8.943 8.943 0 0 1-.109-2.358c.931 0 1.862-.008 2.792 0 .851 0 1.2.345 1.179 1.214-.008.376.128.778-.105 1.14z",
    transform: "translate(1020.95 252.23)",
    style: {
      fill: "#fefefe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45617",
    d: "M-1104.425-284.817a.829.829 0 0 0 .9.6q1.484.016 2.968 0a.824.824 0 0 0 .892-.608c.337.995-.066 1.6-1.072 1.609q-1.3.008-2.607 0c-1.012-.001-1.412-.6-1.081-1.601z",
    transform: "translate(1130.616 300.183)",
    style: {
      fill: "#cbd0d8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45618",
    d: "M-1062.523-284.817a.829.829 0 0 0 .9.6q1.484.016 2.969 0a.824.824 0 0 0 .892-.608c.337.995-.066 1.6-1.072 1.609q-1.3.008-2.607 0c-1.013-.001-1.413-.6-1.082-1.601z",
    transform: "translate(1095.697 300.183)",
    style: {
      fill: "#cbd0d8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45619",
    d: "M-1020.62-284.817a.829.829 0 0 0 .9.6q1.484.016 2.969 0a.823.823 0 0 0 .892-.608c.337.995-.066 1.6-1.072 1.609q-1.3.008-2.607 0c-1.013-.001-1.413-.6-1.082-1.601z",
    transform: "translate(1060.778 300.183)",
    style: {
      fill: "#cbd0d8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45620",
    d: "M-978.717-284.817a.829.829 0 0 0 .9.6q1.484.016 2.968 0a.824.824 0 0 0 .893-.608c.337.995-.066 1.6-1.072 1.609q-1.3.008-2.607 0c-1.014-.001-1.413-.6-1.082-1.601z",
    transform: "translate(1025.859 300.183)",
    style: {
      fill: "#cbd0d8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45621",
    d: "M-1188.23-284.817a.829.829 0 0 0 .9.6q1.484.016 2.968 0a.824.824 0 0 0 .892-.608c.337.995-.066 1.6-1.072 1.609q-1.3.008-2.607 0c-1.013-.001-1.412-.6-1.081-1.601z",
    transform: "translate(1200.453 300.183)",
    style: {
      fill: "#cbd0d8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45622",
    d: "M-1230.133-284.817a.829.829 0 0 0 .9.6q1.484.016 2.968 0a.824.824 0 0 0 .893-.608c.337.995-.066 1.6-1.072 1.609q-1.3.008-2.607 0c-1.013-.001-1.413-.6-1.082-1.601z",
    transform: "translate(1235.372 300.183)",
    style: {
      fill: "#cbd0d8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45623",
    d: "M-1146.328-284.817a.829.829 0 0 0 .9.6q1.484.016 2.969 0a.823.823 0 0 0 .892-.608c.337.995-.066 1.6-1.072 1.609q-1.3.008-2.607 0c-1.013-.001-1.413-.6-1.082-1.601z",
    transform: "translate(1165.535 300.183)",
    style: {
      fill: "#cbd0d8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45624",
    d: "M-1104.425-242.918a.829.829 0 0 0 .9.6q1.484.016 2.969 0a.823.823 0 0 0 .892-.608c.337.995-.066 1.6-1.072 1.609q-1.3.008-2.607 0c-1.013-.001-1.413-.6-1.082-1.601z",
    transform: "translate(1130.616 265.268)",
    style: {
      fill: "#cbd0d8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45625",
    d: "M-1062.523-242.918a.829.829 0 0 0 .9.6q1.484.016 2.969 0a.824.824 0 0 0 .892-.608c.337.995-.066 1.6-1.072 1.609q-1.3.008-2.607 0c-1.013-.001-1.413-.6-1.082-1.601z",
    transform: "translate(1095.697 265.268)",
    style: {
      fill: "#cbd0d8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45626",
    d: "M-936.815-242.918a.83.83 0 0 0 .9.6q1.484.016 2.969 0a.823.823 0 0 0 .892-.607c.337.995-.066 1.6-1.072 1.609q-1.3.008-2.607 0c-1.013-.002-1.413-.601-1.082-1.602z",
    transform: "translate(990.941 265.268)",
    style: {
      fill: "#cbd0d8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45627",
    d: "M-1020.72-333.507a2.438 2.438 0 0 0 2.308 1.741 2.466 2.466 0 0 0 2.435-1.743 2.226 2.226 0 0 1-1.183 2.453 2.548 2.548 0 0 1-3.67-1.809c-.026-.21-.097-.458.11-.642z",
    transform: "translate(1060.886 340.757)",
    style: {
      fill: "#cbd0d8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45628",
    d: "M-1062.622-333.507a2.439 2.439 0 0 0 2.308 1.741 2.466 2.466 0 0 0 2.435-1.743 2.226 2.226 0 0 1-1.183 2.453 2.547 2.547 0 0 1-3.67-1.809c-.027-.21-.097-.458.11-.642z",
    transform: "translate(1095.805 340.757)",
    style: {
      fill: "#cbd0d8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45629",
    d: "M-978.817-333.507a2.438 2.438 0 0 0 2.308 1.741 2.466 2.466 0 0 0 2.435-1.743 2.226 2.226 0 0 1-1.183 2.453 2.547 2.547 0 0 1-3.67-1.809c-.027-.21-.097-.458.11-.642z",
    transform: "translate(1025.967 340.757)",
    style: {
      fill: "#cbd0d8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45630",
    d: "M-1104.525-333.507a2.438 2.438 0 0 0 2.308 1.741 2.465 2.465 0 0 0 2.435-1.743 2.226 2.226 0 0 1-1.183 2.453 2.548 2.548 0 0 1-3.67-1.809c-.026-.21-.097-.458.11-.642z",
    transform: "translate(1130.723 340.757)",
    style: {
      fill: "#cbd0d8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45631",
    d: "M-936.914-333.507a2.438 2.438 0 0 0 2.308 1.741 2.466 2.466 0 0 0 2.435-1.743 2.226 2.226 0 0 1-1.183 2.453 2.547 2.547 0 0 1-3.67-1.809c-.027-.21-.097-.458.11-.642z",
    transform: "translate(991.048 340.757)",
    style: {
      fill: "#cbd0d8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45632",
    d: "M-1146.427-333.507a2.439 2.439 0 0 0 2.308 1.741 2.466 2.466 0 0 0 2.435-1.743 2.226 2.226 0 0 1-1.183 2.453 2.547 2.547 0 0 1-3.67-1.809c-.027-.21-.097-.458.11-.642z",
    transform: "translate(1165.642 340.757)",
    style: {
      fill: "#cbd0d8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45633",
    d: "M-1188.33-333.507a2.438 2.438 0 0 0 2.308 1.741 2.466 2.466 0 0 0 2.435-1.743 2.226 2.226 0 0 1-1.183 2.453 2.547 2.547 0 0 1-3.67-1.809c-.027-.21-.097-.458.11-.642z",
    transform: "translate(1200.561 340.757)",
    style: {
      fill: "#cbd0d8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45634",
    d: "M-1230.233-333.507a2.438 2.438 0 0 0 2.308 1.741 2.466 2.466 0 0 0 2.435-1.743 2.226 2.226 0 0 1-1.183 2.453 2.548 2.548 0 0 1-3.67-1.809c-.027-.21-.097-.458.11-.642z",
    transform: "translate(1235.48 340.757)",
    style: {
      fill: "#cbd0d8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45635",
    d: "M-1020.62-242.918a.829.829 0 0 0 .9.6q1.484.016 2.969 0a.824.824 0 0 0 .892-.608c.229.261.068.575.116.86l-.748.749h-3.044c-1.014 0-1.416-.599-1.085-1.601z",
    transform: "translate(1060.778 265.268)",
    style: {
      fill: "#cbd0d8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45636",
    d: "M-1146.381-242.918a.829.829 0 0 0 .9.6q1.484.016 2.969 0a.823.823 0 0 0 .892-.608c.337 1-.066 1.6-1.077 1.609s-2.031 0-3.047 0a3.663 3.663 0 0 0-.747-.748c.043-.28-.116-.592.11-.853z",
    transform: "translate(1165.588 265.268)",
    style: {
      fill: "#cbd0d8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45637",
    d: "M-978.771-242.918a.829.829 0 0 0 .9.6q1.484.016 2.969 0a.824.824 0 0 0 .893-.608c.337 1-.066 1.6-1.075 1.609s-2.03 0-3.045 0a3.382 3.382 0 0 0-.751-.752c.043-.277-.12-.589.109-.849z",
    transform: "translate(1025.913 265.268)",
    style: {
      fill: "#cbd0d8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45638",
    d: "M-1230.133-201.02a.829.829 0 0 0 .9.6q1.484.016 2.969 0a.824.824 0 0 0 .892-.608c.2.172.084.405.118.609a2.047 2.047 0 0 0-1.752 1h-2.047c-1.012-.002-1.411-.601-1.08-1.601z",
    transform: "translate(1235.373 230.352)",
    style: {
      fill: "#cbd0d8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45639",
    d: "M-936.842-201.019a.829.829 0 0 0 .9.605q1.484.016 2.969 0a.823.823 0 0 0 .893-.608c.337.995-.066 1.6-1.072 1.609-.683.005-1.366 0-2.048 0a2.047 2.047 0 0 0-1.753-1c.029-.203-.087-.435.111-.606z",
    transform: "translate(990.968 230.352)",
    style: {
      fill: "#cbd0d8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45640",
    d: "M-1100.54-190.392h-15.955v-1.992a1.121 1.121 0 0 1 .824-.2q7.153-.007 14.307 0a1.112 1.112 0 0 1 .823.2z",
    transform: "translate(1140.579 223.324)",
    style: {
      fill: "#e5e8ec"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45641",
    d: "M-1100.54-196.377h-15.955v-1h15.953l.002 1z",
    transform: "translate(1140.579 227.319)",
    style: {
      fill: "#cbd0d8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45642",
    d: "m-996.953-219.9.025-1.353c.728.129.979.4.98 1.109q.007 5.359 0 10.718a1.2 1.2 0 0 1-.11.6c-.161.293-.407.555-.726.483s-.155-.43-.156-.656q-.016-5.453-.013-10.901z",
    transform: "translate(1040.979 247.214)",
    style: {
      fill: "#d2b0a8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45643",
    d: "M-972.743-218.072a1.609 1.609 0 0 1 .75-.995c.194.161.125.383.125.582 0 3.612 0 7.224.006 10.836a1.065 1.065 0 0 1-.508 1.055c-.325.182-.5.131-.5-.286.01-.747 0-1.494 0-2.242v-7.847a3.672 3.672 0 0 1 .127-1.103z",
    transform: "translate(1020.888 245.389)",
    style: {
      fill: "#d2b0a8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45644",
    d: "m-1164.535-219.785.019-1.48c.728.128.983.4.984 1.106q.007 5.391.005 10.782a1.1 1.1 0 0 1-.173.65c-.16.232-.39.447-.663.383-.293-.069-.158-.389-.159-.6q-.015-5.418-.013-10.841z",
    transform: "translate(1180.626 247.221)",
    style: {
      fill: "#d2b0a8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45645",
    d: "M-1140.38-218.09a1.607 1.607 0 0 1 .751-.992c.194.16.127.383.127.582q.005 5.355 0 10.71a1.274 1.274 0 0 1-.4 1.12c-.126.1-.28.214-.454.146-.205-.08-.135-.282-.136-.436-.006-.872 0-1.743 0-2.615v-7.41a4.1 4.1 0 0 1 .112-1.105z",
    transform: "translate(1160.587 245.402)",
    style: {
      fill: "#d2b0a8"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalIcon4);
export default __webpack_public_path__ + "static/media/modalIcon4.906526c1f2c506f6faded5c2ef86788f.svg";
export { ForwardRef as ReactComponent };